import React, { useState, useEffect } from 'react';
import { Fade } from '@mui/material';

interface EmailProgressSSEProps {
  progressMessage: string;
  [key: string]: any;
}

const EmailProgressSSE: React.FC<EmailProgressSSEProps> = ({ progressMessage, ...props }) => {
  const [visibleMessage, setVisibleMessage] = useState(progressMessage);
  const [fadeIn, setFadeIn] = useState(true);

  useEffect(() => {
    if (progressMessage !== visibleMessage) {
      setFadeIn(false);
      const fadeOutTimer = setTimeout(() => {
        setVisibleMessage(progressMessage);
        setFadeIn(true);
      }, 300); // Duración del fade out
      return () => clearTimeout(fadeOutTimer);
    }
  }, [progressMessage, visibleMessage]);

  // Para asegurar mínimo 1.5s por mensaje (esto solo retrasa el cambio visual, no la lógica de backend)
  // Si necesitas bloquear el avance de fases, eso debe hacerse en backend o en el controlador de SSE

  return (
    <Fade in={fadeIn} timeout={300}>
      <div style={{ fontSize: '0.875rem', color: 'text.secondary' }}>
        {visibleMessage}
      </div>
    </Fade>
  );
};

export default EmailProgressSSE; 